import Axios from "axios";

export default {
    createCsoDoc: (data , options) => {
        return Axios.post('/Requests/create-cso-request/', data , {headers:options.headers , params:options.params})
    },

    shipmentInfo: (data) => {
        const headers ={'correlationId':1,
                        'originatingChannel':1,
                        'channelRequestId':1,
                        'originatingUserType':1,
                        'originatingUserIdentifier':1,
                        'serviceEntityId': 1,
                        'serviceSlug':1,
                        'responseCode':1}

        return Axios.post('/Requests/ShipmentInfo/', data , {headers:headers})
    },

    InquireRequestStatus: (req_id) => {

        const headers ={
            'RequestID':req_id,
            'correlationId':1,
            'originatingChannel':1,
            'channelRequestId':1,
            'originatingUserType':1,
            'originatingUserIdentifier':1,
            'serviceEntityId': 1,
            'serviceSlug':1,
            'responseCode':1}
            
        return Axios.get('/Requests/InquireRequestStatus/',{headers:headers})
    },

    RequestStatus: (req_id) => {

        const headers ={
            'RequestID':req_id,
            'correlationId':1,
            'originatingChannel':1,
            'channelRequestId':1,
            'originatingUserType':1,
            'originatingUserIdentifier':1,
            'serviceEntityId': 1,
            'serviceSlug':1,
            'responseCode':1}
            
        return Axios.get('/Requests/request-status/',{headers:headers})
    },

    AddVote: (VoteId) => {
        return Axios.post('/Requests/Add-vote/',{}, {  params: {VoteId : VoteId}})
    },
    ContactUs: (data) => {
        return Axios.post('/Requests/Contact-us/',data)
    }
}